const menu = [
  {
    title: '',
    items:[
      {
        label: 'Dashboard',
        path: '/',
        icon: 'ph:house-simple',
      },
    ]
  },
  {
    title: 'OPERATIONS',

    items: [
      {
        label: 'Merchants',
        path: '/merchants',
        icon: 'ph:storefront',
      },

      {
        label: 'POS integrations',
        path: '/pos-integrations',
        icon: 'ph:cash-register',
      },
    ],
  },

  {
    title: 'ADMINISTRATION',

    items: [
      {
        label: 'Reports & analytics',
        path: '/reports-analytics',
        icon: 'ph:chart-bar',
      },
      {
        label: 'User management',
        path: '/user-management',
        icon: 'ph:users',
      },
      {
        label: 'Config & settings',
        path: '/config-settings',
        icon: 'ph:gear-six',
      },
    ],
  },

]

export default menu